import axios from 'axios';
export default {
	getSettlements(zipCode) {
		return axios.get('/apps/postcodes/api/get', {
			params: {
				requestValue: zipCode
			}
		});
	}
};
